import React from 'react'
import AgentTable from './AgentTable'

const Agent = () => {
  return (
    <div>
        <AgentTable />
    </div>
  )
}

export default Agent